module.exports = __webpack_public_path__ + "static/media/merchandise.1dab6316.svg";